import { render, staticRenderFns } from "./MemberProfileSettings.vue?vue&type=template&id=bd1eb2de&scoped=true&lang=pug&"
import script from "./MemberProfileSettings.vue?vue&type=script&lang=js&"
export * from "./MemberProfileSettings.vue?vue&type=script&lang=js&"
import style0 from "./MemberProfileSettings.vue?vue&type=style&index=0&id=bd1eb2de&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1eb2de",
  null
  
)

export default component.exports